import axios from 'axios';

import { requestGet, requestPost, requestPut } from '../request';
import apiPath from './apiPath';

const api = {
  GetOneOrderReport(orderReportID) {
    return requestGet(apiPath.DOWNLOAD.path, { orderID: orderReportID }).then(
      resp => {
        const service = axios.create({ timeout: 60000 });
        return service({
          url: resp.data.data.url,
          method: 'get',
          responseType: 'blob'
        });
      }
    );
  },

  GetOneRawData(orderReportID) {
    return requestGet(apiPath.RAW_DATA.path, { orderID: orderReportID });
  },

  GetAllOrderReport(paging, filtering) {
    return requestGet(apiPath.ORDER.path, {
      page: paging.page,
      size: paging.size,
      f_pdf: filtering.pdf,
      f_startDate: filtering.createdAt.startDate,
      f_endDate: filtering.createdAt.endDate,
      f_outletCode: filtering.outletCode,
      f_filter: filtering.orderId,
      f_orderType: filtering.orderType,
      f_orderStatus: filtering.orderStatus,
      f_cancelStatus: filtering.cancelStatus,
      f_loyaltyPoints: filtering.totalPoints
    });
  },

  GetOneOrderReportDetail(orderReportId, type) {
    return requestGet(apiPath.ORDER_DETAILS.path, {
      type: type,
      orderId: orderReportId
    });
  },

  UpdateOrderStatus(payload) {
    return requestPost(apiPath.UPDATE_ORDER_STATUS.path, payload);
  },

  ChangeCIMBOrderStatus(payload) {
    return requestPost(apiPath.CHANGE_CIMB_ORDER_STATUS.path, payload);
  },

  ChangeCIMBOrderCallback(payload) {
    return requestPost(apiPath.CHANGE_CIMB_ORDER_CALLBACK.path, payload);
  },

  UpdateOrderDetail(payload) {
    return requestPut(apiPath.UPDATE_ORDER_DETAIL.path.replace(':orderId', payload.orderId), payload);
  },

  cancelOrder(payload) {
    return requestPost(apiPath.CNACEL_ORDER.path, payload);
  },

  refundOrder(payload) {
    return requestPost(apiPath.REFUND_ORDER.path, payload);
  },

  GetNewOrder(payload) {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_BO_STATUS_PAYMENT_SUCCESS_GROUP_BY_ORDER_TYPE
          .path
      }`,
      method: 'get',
      params: {
        uid: payload
      }
    });
  },

  SearchMenu(payload) {
    return axios({
      url: `${process.env.VUE_APP_QRAVED_APP_URL}/${
        apiPath.ORDERING_ORDER_API_STORE_MENU_ITEMS_SEARCH.path
      }`,
      method: 'get',
      params: {
        ...payload
      }
    });
  },

  SetOrder(payload) {
    return requestPut(apiPath.ORDER_MENU.path, payload);
  }
};

export default api;
